/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'geofences',
  initialState: {
    items: []
  },
  reducers: {
    update(state, action) {
      action.payload.forEach((item) => (state.items[item.id] = item));
    },
    delete(state, action) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as geofencesActions };
export { reducer as geofencesReducer };

/*-------------------------------------------------------------------------------------------*/
